export default __webpack_public_path__ + "static/media/blackAlert.72f58fbd.svg";